import { useEffect, useRef } from 'react';
import { SubscriptionTypes } from 'types/auth';
import { TCountryCode } from 'countries-list';

// Reload on subscription changes as well as country/org changes. Late responses from
// a previous selection must not replace the new selection's layers.
export function useSubscriptionDataLayers(
  orgId: string | null | undefined,
  countryCodes: TCountryCode[],
  subscription: SubscriptionTypes,
  load: (countries: TCountryCode[], subscription: SubscriptionTypes, isCurrent: () => boolean) => void,
) {
  const loadRef = useRef(load);
  loadRef.current = load;
  const countriesKey = JSON.stringify([...countryCodes].sort());
  useEffect(() => {
    if (!orgId) return;
    let current = true;
    loadRef.current(JSON.parse(countriesKey), subscription, () => current);
    return () => { current = false; };
  }, [orgId, countriesKey, subscription]);
}
